import type { FaireProductEntity } from "../../entity_types/product";

export const p_99et69863t: FaireProductEntity = {
  token: "p_99et69863t",
  type: "product",
  name: "Womens Chakra leggings, 7 Chakra leggings, spiritual",
  brandToken: "b_na6tfqypxs",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/e8bd2370ac7351380b3e975b1355c8a27d81347cfe3fc8a54cd0eda26da4d6ce.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/68d809ffbce34f652c11b72eb14bfbb89d1349e54594f7debd67330ee0c12dd1.jpeg",
    "https://cdn.faire.com/fastly/9b6439b378d5891bf9e78b2ddb4ad61efb434bc2678125d2318358c0b774fc61.jpeg",
    "https://cdn.faire.com/fastly/cc3b76b31f1e24af45019f665080ac8155f0ca92d2cdf21781c6476cea8723ff.jpeg",
    "https://cdn.faire.com/fastly/665a948dfbc0529f23df0e9b9579227c855c0025516bac4598b17a7d78ae7b05.jpeg",
  ],
  priceDollars: 20.79,
  description:
    "Exclusive Womens Chakra Leggings\n\nDesigned to meet your everyday needs Triple Goddess Boutique’s exclusive collection can’t be found anywhere else. With two fully functional pockets designed to fit even the largest phones. 3” wide comfort V- waistband and custom fit to accommodate your unique body shape. The unique fabric blend will stretch to fit whether you are short or tall!\n\nOS fits 2-12\n\nTC fits 12-18\n\n\n92% Polyester, 8% Spandex",
  tags: [],
  msrpDollars: 41.57,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:01.349Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
